export default "__VITE_ASSET__a48c8f5c__"